import { render, staticRenderFns } from "./pcSrefForms.vue?vue&type=template&id=238c778a&scoped=true&"
import script from "./pcSrefForms.vue?vue&type=script&lang=js&"
export * from "./pcSrefForms.vue?vue&type=script&lang=js&"
import style0 from "./pcSrefForms.vue?vue&type=style&index=0&id=238c778a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c778a",
  null
  
)

export default component.exports